import {
  Container,
  Box,
  Grid,
  Card,
  CardContent,
  IconButton,
  Link,
  Hidden,
  Button,
  Typography,
  Paper,
  FormControl,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import { useFormContext, Controller } from "react-hook-form";

import { useSharedBookReducer } from "../state";

const SidebarNotes = (props) => {
  const [bookState, dispatch] = useSharedBookReducer();
  const { register, control } = useFormContext();

  const handleChangeNote = (e) => {
    dispatch({
      type: "MERGE",
      payload: {
        m: { notes: e.target.value },
      },
    });
  };

  return (
    <>
      {/* Promo.details.title?? */}
      {/* <Card>
        <CardContent> */}
      <Typography variant="body1">Additional Notes</Typography>
      {/* <TextField
            value={bookState.m.notes}
            onChange={handleChangeNote}
            size="small"
            margin="dense"
            fullWidth
          /> */}
      <Controller
        name="notes"
        control={control}
        defaultValue=""
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            placeholder="Add Notes Here"
            size="small"
            margin="dense"
            fullWidth
            error={fieldState.invalid ? true : false}
          />
        )}
        shouldUnregister
      />
      {/* </CardContent>
      </Card> */}

      {/* 
					<div class="box">
						{{{marked (kv 'page.create.additional-notes')}}}
						<div class="field">
							<div class="field-body">
								<div class="field">
									<div class="control is-expanded">
										<input class="input" type="text" placeholder="" name="notes" v-model="m.notes">
									</div>
								</div>
							</div>
						</div>
					</div>

       */}
    </>
  );
};

export default SidebarNotes;
